import React from "react";
import "./checkbox_comp.scss";
import { Checkbox } from "antd";

function CheckboxComp({
  onChange = () => {},
  label,
  isChecked,
  setChecked = () => {},
  indeterminate,
  disabled = false,
}) {
  const onCheckChange = (e) => {
    setChecked(e.target.checked);
    onChange(e.target.checked);
  };

  return (
    <Checkbox
      checked={isChecked}
      indeterminate={indeterminate}
      disabled={disabled}
      className="checkbox-comp"
      onChange={onCheckChange}
    >
      {label}
    </Checkbox>
  );
}

export default CheckboxComp;
